export class ZoomToPointParameters {
  function: string;
  easting1: number;
  northing1: number;
  scale: number;
  valid: boolean;
  workspace?: string;
}
